import { Box } from 'braid-design-system';

export const MainContent = () => <Box />;
